var _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgAppLogo = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 536,
    height: 518,
    viewBox: "0 0 536 518",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M227.88 384.959C178.376 377.986 154.948 320.07 185.679 280.639L244.307 205.415C275.078 165.933 337.057 174.593 355.828 220.997L391.641 309.525C410.413 355.93 371.887 405.245 322.319 398.263L227.88 384.959Z",
    fill: "#1983B1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M317.86 134.267C365.411 118.866 411.826 160.659 401.48 209.558L386.512 280.317C376.149 329.297 316.629 348.665 279.426 315.167L225.587 266.691C188.383 233.191 201.425 171.974 249.053 156.549L317.86 134.267Z",
    fill: "#8A17D4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M139.595 215.067C135.838 165.832 186.183 130.547 231.182 150.879L313.683 188.155C359.59 208.897 365.479 271.718 324.226 300.63L248.617 353.621C207.364 382.533 150.322 355.564 146.489 305.333L139.595 215.067Z",
    fill: "url(#app-logo-gradient-unique)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M201.918 308.29C164.716 272.795 181.498 210.204 231.467 198.081L275.571 187.381C323.542 175.742 366.471 219.712 353.688 267.391L342.419 309.42C329.636 357.099 270.468 373.694 234.753 339.619L201.918 308.29Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "app-logo-gradient-unique",
    x1: 167.107,
    y1: 156.884,
    x2: 286.421,
    y2: 327.126,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D4145A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6B3091"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgAppLogo, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/AppLogo.bca5b983.svg";
export { ForwardRef as ReactComponent };